exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wrapper--3rQuE {\n  padding: 20px 10px;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border-bottom: 1px solid #C0C0C0;\n}\n\n.summary--2f9sv {\n  display: grid;\n  width: 100%;\n  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;\n  grid-auto-columns: 1fr;\n  grid-column-gap: 10px;\n  line-height: 20px;\n}\n\n.summary--2f9sv > * {\n  -ms-flex-item-align: center;\n      align-self: center;\n  text-align: center;\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 20px;\n}\n\n.controls--1TZ_V {\n  width: 100%;\n  min-width: 260px;\n  height: 100%;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  -ms-flex-pack: center;\n      justify-content: center;\n}\n\n.controls--1TZ_V .button--1S7f2 {\n  margin-bottom: 5px;\n}\n", ""]);

// exports
exports.locals = {
	"wrapper": "wrapper--3rQuE",
	"summary": "summary--2f9sv",
	"controls": "controls--1TZ_V",
	"button": "button--1S7f2"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"minimize":false,"sourceMap":false,"localIdentName":"[local]--[hash:base64:5]","importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","sourceMap":false,"plugins":[null,null]}!./node_modules/sass-loader/dist/cjs.js?{"data":"$env: production;","sourceMap":false,"outputStyle":"expanded","precision":10,"includePaths":["/app/node_modules","/app/src"]}!./src/components/list-items/ProcessingUser/ProcessingUser.m.scss
// module id = 1578
// module chunks = 0